import React from "react";
import ProjectPageEditor from "./markdown-editor"

function App() {

  const [full, setFull] = React.useState(false);
  const [textValue, setTextValue] = React.useState(`
  :::dark-mode
  :::
  # Paper Title
  :::author
  [First Author^1^](person_website_link), [Second Author^2^](person_website_link), [Third Author^2^](person_website_link)
  :::
  
  :::institution
  <span>^1^Foo Bar Institution,</span> <span>^2^Foo Bar University</span>
  :::
  
  :::button
  [<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
  Paper](paper_link) [&#129303; Demo](demo_link) [<i class="fa fa-github" aria-hidden="true"></i>
  Code](code_link)
  :::
  
 ## Abstract
 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ornare gravida mauris, non fermentum orci tristique vitae. In lobortis vehicula consequat. Suspendisse eu quam sem. Fusce velit arcu, gravida ut porttitor nec, egestas quis erat. Donec tempor cursus dolor. In bibendum euismod eleifend. Sed sit amet auctor metus, eget efficitur risus. Vestibulum est tortor, lacinia non felis quis, pharetra tempor nisi. Sed molestie semper tempus. Ut eu egestas nunc, at iaculis sapien. Mauris justo dolor, varius id ultricies vitae, pretium id ante. Suspendisse egestas ultrices ex, quis vestibulum arcu sodales eu.
  

## Banner Image
![Banner Image](https://cdn.pixabay.com/photo/2018/06/24/08/17/colorful-abstract-background-3494093_1280.jpg)

::: caption
This is an image caption
:::

## Youtube Video

@[youtube](JkaxUblCGz0)

## Local Video

@[video](https://eliahuhorwitz.github.io/Academic-project-page-template/static/videos/banner_video.mp4)

## BibTex

\`\`\`
BitTex goes here
\`\`\`

:::: carousel

::: carousel-cell
![Banner Image](https://cdn.pixabay.com/photo/2018/06/24/08/17/colorful-abstract-background-3494093_1280.jpg)
Caption 1
:::

::: carousel-cell
![Banner Image](https://cdn.pixabay.com/photo/2017/02/20/18/03/cat-2083492_1280.jpg)
Caption 2
:::

::: carousel-cell
![Banner Image](https://cdn.pixabay.com/photo/2018/06/24/08/17/colorful-abstract-background-3494093_1280.jpg)
Caption 3
:::

::::

:::: carousel

::: carousel-cell
@[video](https://eliahuhorwitz.github.io/Academic-project-page-template/static/videos/banner_video.mp4)
Caption 1
:::

::: carousel-cell
@[video](https://eliahuhorwitz.github.io/Academic-project-page-template/static/videos/banner_video.mp4)
Caption 2
:::

::: carousel-cell
@[video](https://eliahuhorwitz.github.io/Academic-project-page-template/static/videos/banner_video.mp4)
Caption 3
:::

::::

`);



  return (
    <div className="App">
      <ProjectPageEditor
              setFull={setFull}
              full={full}
              textValue={textValue}
              setTextValue={setTextValue}
            />
    </div>
  );
}

export default App;
